export default "__VITE_ASSET__CkyGQILh__"